import { HTTP, rootApi, SuccessResponse } from '../index';
import { FreightRule, FreightRuleResponse, FreightRulesResponse } from './types';

export const freightRuleApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getFreightRules: builder.query<FreightRulesResponse, void>({
      query: () => {
        return {
          url: `/freight_rules`,
          method: HTTP.GET,
        };
      },
      providesTags: ['FreightRule'],
    }),

    getFreightRule: builder.query<FreightRuleResponse, number>({
      query: (id) => ({
        url: `/freight_rules/${id}`,
        method: HTTP.GET,
      }),
      providesTags: (result, error, id) => [{ type: 'FreightRule', id }],
    }),

    createFreightRule: builder.mutation<SuccessResponse, FreightRule>({
      query: (body) => {
        return {
          url: `/freight_rules`,
          method: HTTP.POST,
          body: { freight_rule: body },
        };
      },
      invalidatesTags: ['FreightRule'],
    }),

    // supplier_id for manual supplier
    updateFreightRule: builder.mutation<SuccessResponse, FreightRule &
      { supplier_id?: number }>({
      query: (body) => {
        const payload: Record<string, any> = { freight_rule: body };

        if (body.supplier_id !== undefined) {
          payload.supplier_id = body.supplier_id;
        }
        
        return {
          url: `/freight_rules/${body.id}`,
          method: HTTP.PATCH,
          body: payload,
        };
      },
      invalidatesTags: ['FreightRule'],
    }),

    deleteFreightRule: builder.mutation<SuccessResponse, number>({
      query: (id) => {
        return {
          url: `/freight_rules/${id}`,
          method: HTTP.DELETE,
        };
      },
      invalidatesTags: ['FreightRule'],
    }),

    getFreightRuleByCustomer: builder.query<FreightRuleResponse, { supplierId: number, customerId?: number | null }>({
      query: ({ supplierId, customerId }) => ({
        url: `/freight_rules/by_customer`,
        method: HTTP.GET,
        params: {
          supplier_id: supplierId,
          customer_id: customerId,
        },
      }),
      providesTags: ['FreightRuleByCustomer'],
    }),

  }),

  overrideExisting: true,
});

export const {
  useGetFreightRulesQuery,
  useGetFreightRuleQuery,
  useCreateFreightRuleMutation,
  useUpdateFreightRuleMutation,
  useDeleteFreightRuleMutation,
  useGetFreightRuleByCustomerQuery,
} = freightRuleApi;
